
import { Component, Prop, Vue } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { TreeNode } from "@/types/tree";
import { documentStore, uiStore } from "@/store/store-accessor";
import { shuffleSection } from "@/subapps/onboarding/lib/pages";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    Icon
  }
})
export default class NodeOnboardingReplaceSectionButton extends Vue {
  @Prop()
  element!: TreeNode;

  replaceSection() {
    uiStore.activateElement(this.element.id);

    shuffleSection(this.element.id);

    logEvent("Onboarding", {
      action: "onboarding_app_ui_interaction",
      type: "node_shuffle_section_button"
    });

    window.parent.postMessage(
      {
        id: "",
        type: "RESPONSE",
        payload: {
          success: true,
          payload: {
            message: "Element activated",
            elementId: this.element.id,
            tree: documentStore.document.tree.root.children,
            document: documentStore.document
          }
        }
      },
      "*"
    );
  }
}
